<template>
  <toggle-button
    :width="35"
    :height="20"
    class="mb-0"
    @change="updateQuizFastAnswerGetMorePoint()"
    v-model="slideActive.fastAnswerGetMorePoint"
    :color="{checked: '#348EF6', unchecked: '#D3D7E1'}"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/util'
import gaCategories from '@/constant/gaCategories'
import Socket from '@/socket'
import SlideApi from '@/api/slide'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncPresentationAction']),
    updateQuizFastAnswerGetMorePoint() {
      this._updateSlide({
        presentationId: this.presentation.id,
        accessCode: this.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
        presenting: this.$store.getters.isPresenting,
        fastAnswerGetMorePoint: this.slideActive.fastAnswerGetMorePoint,
      })
    },
    async _updateSlide(payload) {
      this.setSyncPresentationAction(1)
      try {
        await SlideApi.updateSlideById(this.slideActive.id, payload)
        this.handleAfterUpdateSlide()
        this.setSyncPresentationAction(2)
      } catch {
        this.setSyncPresentationAction(3)
      }
    },
    handleAfterUpdateSlide() {
      this.updateSlideActiveAction({
        fastAnswerGetMorePoint: this.slideActive.fastAnswerGetMorePoint,
      })
      utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Right column > Edit setting > Faster answers get more points',
        `Presenter edit fast answer get more point: ${
          this.slideActive.fastAnswerGetMorePoint}`,
      )
    },
  },
}
</script>
